/*eslint-disable multiline-ternary */
/*eslint-disable no-duplicate-imports */
import React, { useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import './FileUpload.scss';
import CircularProgressWithLabel from './ProgressComponent';
import { FileUploadIconSVG } from './img/FileUploadSVG';
import { NotificationSVG } from '../../Member/img/GlobalSVG';

/**
 * @method formatFileBytes
 * @param {byte}
 * @usage <formatFileBytes(1000000)>
 *         1000000  =>  Bytes
 * @return {String} =>  1 MB
 */

export function formatFileBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';

  const defaultBytes = 1024;
  const decimalPosition = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const arrayIdx = Math.floor(Math.log(bytes) / Math.log(defaultBytes));

  return `${parseFloat(
    (bytes / defaultBytes ** arrayIdx).toFixed(decimalPosition),
  )} ${sizes[arrayIdx]}`;
}

export default function FileInfo({
  files,
  fileDetails,
  setFiles,
  filesLoader,
  setFieldValue,
  fileProgress,
  fileUploadStatus,
  showRemove = true,
  readFileSize = true,
  isComingFromPortalTiPortal = false,
  handleDeleteAttachment = null,
  browseFileSeactionFocus,
}) {
  //const [ progress, setProgress ] = useState( 0 );
  //const [ uploadStatus, setUploadStatus ] = useState( 'pending' );

  //useEffect( () => {
  //const timer = setInterval( () => {
  //setProgress( ( prevProgress ) => ( prevProgress >= 100 ? 100 : prevProgress + 10 ) );
  //}, 800 );
  //return () => {
  //clearInterval( timer );
  //};
  //}, [] );
  //useEffect ( () => {
  //if ( fileProgress === 100 ) {
  //setUploadStatus( 'uploaded' );
  //}
  //}, [ progress ] );

  const onDelete = (file) => {
    const fileData = [...files];
    const filteredData = fileData.filter((item) => item?.file !== file);
    setFiles([...filteredData]);
    setFieldValue('file', filteredData.length > 0 ? { ...filteredData } : '');
    !filteredData.length &&
      browseFileSeactionFocus &&
      browseFileSeactionFocus.current &&
      browseFileSeactionFocus.current.focus();
  };

  const onDeleteCallWithAPI = (file) => {
    const fileData = [...files];
    //this below function is using in deleting the attachments in portal to portal Publish Message

    console.log('fun');
    const res = handleDeleteAttachment(
      fileData.filter((item) => item?.file === file)[0],
    );
    res
      .then((res) => {
        if (res === 'success') {
          const filteredData = fileData.filter((item) => item?.file !== file);
          setFiles([...filteredData]);
          setFieldValue(
            'file',
            filteredData.length > 0 ? { ...filteredData } : '',
          );
        }
      })
      .catch((err) => console.log('err', err));
  };

  //const onFilesLoader=()=>{
  //console.log( 'files--@', files );
  //console.log( 'fileDetails--@', fileDetails );
  //const timer = setInterval( () => {
  //setProgress( ( prevProgress ) => ( prevProgress >= 100 ? 100 : prevProgress + 10 ) );
  //}, 800 );
  //return () => {
  //clearInterval( timer );
  //};
  //};
  //console.log( 'files--@', files );
  //console.log( 'fileDetails--@', fileDetails );
  //console.log( 'fileProgress--@', fileProgress );
  return (
    <div className="File-information-content">
      {filesLoader && 1 ? (
        <Row className="m-0">
          <Col md={12} lg={12} sm={12} className="">
            <div className="files-container shadow-none">
              <div className="img-text-class">
                {fileProgress === 100 ? (
                  <FileUploadIconSVG />
                ) : (
                  <CircularProgressWithLabel value={fileProgress} />
                )}
                <div className="files-information">
                  <span className="file-name">
                    {fileDetails?.file?.name ? fileDetails?.file?.name : null}
                  </span>
                  <br />
                  <span className="file-size">
                    {fileProgress === 100 ? (
                      fileUploadStatus === 'uploaded' ? (
                        <>
                          <div
                            className="sr-only"
                            role="alert"
                          >{`${fileDetails?.file?.name} is Uploaded Successfully`}</div>
                          <span className="uploading-files success">
                            Uploaded Successfully
                          </span>
                        </>
                      ) : fileUploadStatus === 'failed' ? (
                        <>
                          <div
                            className="sr-only"
                            role="alert"
                          >{`${fileDetails?.file?.name} is Failed to Upload`}</div>
                          <span className="uploading-files failed">
                            Failed to Upload
                          </span>
                        </>
                      ) : (
                        <span className="uploading-files"></span>
                      )
                    ) : (
                      <>
                        <div
                          className="sr-only"
                          role="alert"
                        >{`${fileDetails?.file?.name} is Uploading`}</div>
                        <span className="uploading-files">Uploading...</span>
                      </>
                    )}
                  </span>
                </div>
              </div>
              {!isComingFromPortalTiPortal && (
                <div className="deleteorcancel">
                  {fileUploadStatus !== 'uploaded' ? (
                    showRemove && (
                      <GenericButton
                        variant="secondary"
                        tabIndex={0}
                        ariaLabel="Click Remove to delete the file selected for upload"
                        onClick={() => onDelete(fileDetails.file)}
                      >
                        Remove
                      </GenericButton>
                    )
                  ) : (
                    <NotificationSVG.CheckMarkSVG />
                  )}
                </div>
              )}
              {isComingFromPortalTiPortal && (
                <div className="deleteorcancel">
                  <GenericButton
                    variant="secondary"
                    tabIndex={0}
                    ariaLabel="Click Remove to delete the file selected for upload"
                    onClick={() => onDeleteCallWithAPI(fileDetails.file)}
                  >
                    Delete
                  </GenericButton>
                </div>
              )}
            </div>
          </Col>
        </Row>
      ) : (
        <Row className="m-0">
          <Col md={12} lg={12} sm={12} className="">
            <div className="files-container">
              <div className="img-text-class">
                <FileUploadIconSVG />
                <div className="files-information">
                  <span className="file-name">
                    {fileDetails?.file?.name ? fileDetails?.file?.name : null}
                  </span>
                  <br />
                  {readFileSize ? (
                    <span className="file-size">
                      {fileDetails?.file?.size
                        ? `Size: ${formatFileBytes(fileDetails?.file?.size)}`
                        : null}
                    </span>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className="deleteorcancel">
                {fileUploadStatus !== 'uploaded' ? (
                  showRemove && (
                    <GenericButton
                      variant="secondary"
                      tabIndex={0}
                      ariaLabel="Click Remove to delete the file selected for upload"
                      onClick={() => onDelete(fileDetails.file)}
                    >
                      Remove
                    </GenericButton>
                  )
                ) : (
                  <NotificationSVG.CheckMarkSVG />
                )}
              </div>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
}
